import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function NewsletterForm({ variant = "light" }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [busy, setBusy] = useState(false);

  const dark = variant === "dark";

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email, role: role || null });
      if (data.duplicate) {
        toast.success("You are already on the list.");
      } else {
        toast.success("Subscribed. Welcome aboard.");
      }
      setEmail("");
      setRole("");
    } catch (err) {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const inputBase =
    "w-full px-4 py-3 border bg-transparent font-sans text-sm transition-colors duration-200 focus:outline-none";
  const inputClass = dark
    ? `${inputBase} border-white/25 text-white placeholder-white/40 focus:border-white`
    : `${inputBase} border-[var(--eai-border)] text-[var(--eai-ink)] placeholder-[var(--eai-ink-2)] focus:border-[var(--eai-ink)]`;

  return (
    <form onSubmit={submit} className="flex flex-col gap-3" data-testid="newsletter-form">
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-3">
        <input
          type="email"
          required
          placeholder="ethicalainow@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`${inputClass} sm:col-span-3`}
          data-testid="newsletter-email-input"
        />
        <input
          type="text"
          placeholder="Your role (optional)"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className={`${inputClass} sm:col-span-2`}
          data-testid="newsletter-role-input"
        />
      </div>
      <button
        type="submit"
        disabled={busy}
        className={`inline-flex items-center justify-center gap-2 px-5 py-3 text-sm font-medium transition-colors duration-200 ${
          dark
            ? "bg-white text-[var(--eai-ink)] hover:bg-[var(--eai-accent)] hover:text-white"
            : "bg-[var(--eai-ink)] text-white hover:bg-[var(--eai-accent)]"
        } disabled:opacity-60 w-fit`}
        data-testid="newsletter-submit-btn"
      >
        {busy ? "Subscribing…" : "Subscribe to the briefing"}
        <ArrowRight size={16} />
      </button>
      <p className={`text-xs ${dark ? "text-white/40" : "text-[var(--eai-ink-2)]"}`}>
        One email per week. Unsubscribe anytime.
      </p>
    </form>
  );
}
